import styled from 'styled-components';
import FleetMenu from './FleetMenu';

export default styled(FleetMenu)`
  .menu-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .collapseButton {
    height: 48px;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    background: transparent;
    border: 0;
    width: 100%;
    outline: none;
    padding: 0;

    &.collapsed {
      span {
        transform: rotate(0);
      }
    }
    span {
      transform: rotate(180deg);
      display: flex;
      width: 56px;
      height: 48px;
      align-items: center;
      justify-content: center;
    }
    &:hover {
      span {
        background-color: #4e667e;
      }
    }
  }

  .menu-item {
    display: block;
    height: 48px;
    display: flex;
    align-items: center;
    text-decoration: none;
    font-weight: 500;
    text-transform: uppercase;
    padding: 0;
    justify-content: center;

    &.show {
      padding: 0 16px;
      justify-content: flex-start;
    }

    .menu-item__text {
      opacity: 0;
      transition: opacity 0.5s;
      white-space: nowrap;
      flex: 0;
      &.show {
        opacity: 1;
        flex: 1;
        transition: opacity 0.5s;
      }
    }

    &,
    &:active,
    &:visited {
      background-color: var(--grey800);
      color: white;
    }

    &:hover {
      background-color: #4e667e;
    }

    &__active {
      &,
      &:active,
      &:visited {
        background-color: var(--grey300);
        color: var(--grey800);
      }
    }
  }
`;
